import { api } from "@/redux/api";

import {
	AdminFeaturesResponse,
	AdminFeaturesResponseSchema,
	CreateCompanyFeature,
	AdminFeature,
} from "../../pages/FeatureManagement/schema/admin-feature";

export const adminFeatureApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getAdminFeatures: builder.query<AdminFeaturesResponse, void>({
			query: () => ({
				url: "features/admin",
				responseSchema: AdminFeaturesResponseSchema,
			}),
			providesTags: ["AdminFeatures"],
		}),
		toggleFeature: builder.mutation<AdminFeature, { id: number; active: boolean }>({
			query: ({ id, active }) => ({
				url: `features/${id}`,
				method: "PATCH",
				body: { active },
			}),
			invalidatesTags: ["AdminFeatures"],
		}),
		createCompanyFeature: builder.mutation<AdminFeature, CreateCompanyFeature>({
			query: (body) => ({
				url: "features/company",
				method: "POST",
				body,
			}),
			invalidatesTags: ["AdminFeatures"],
		}),
		deleteFeature: builder.mutation<void, number>({
			query: (id) => ({
				url: `features/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["AdminFeatures"],
		}),
	}),
});

export const {
	useGetAdminFeaturesQuery,
	useToggleFeatureMutation,
	useCreateCompanyFeatureMutation,
	useDeleteFeatureMutation,
} = adminFeatureApi;
